import React from "react";
import { Link } from "react-router-dom";
import { FiArrowUpRight, FiMapPin } from "react-icons/fi";

import { properties } from "./data";
import {
  renderCardFeatures,
  CategoryBadge,
} from "./renderFeatures";

export default function Property() {
  const featured = [...properties]
    .sort((a, b) => (b.priority || 0) - (a.priority || 0))
    .slice(0, 6);

  return (
    <div className="container lg:mt-24 mt-16">
      <div className="text-center max-w-2xl mx-auto pb-12">
        <p className="font-display italic text-gold-600 tracking-[0.3em] uppercase text-xs md:text-sm mb-4">
          — Featured —
        </p>
        <h3 className="font-display text-3xl md:text-4xl text-slate-900 dark:text-white mb-4">
          A Curated Florida Portfolio
        </h3>
        <div className="flex items-center justify-center gap-3 mb-5">
          <span className="h-px w-10 bg-gold-500/70"></span>
          <span className="text-gold-600 text-lg">✦</span>
          <span className="h-px w-10 bg-gold-500/70"></span>
        </div>
        <p className="text-slate-500 dark:text-slate-400 leading-relaxed">
          Two one-of-a-kind waterfront rentals — a turnkey Hernando Beach home with direct Gulf access, and a rare grandfathered liveaboard slip at Islamorada's Lorelei Cabana Bar.
        </p>
      </div>

      <div className="grid lg:grid-cols-2 grid-cols-1 mt-8 gap-10 max-w-6xl mx-auto">
        {featured.map((item, index) => (
          <Link
            to={`/property-detail/${item.id}`}
            key={index}
            className="group block bg-white dark:bg-slate-900 ring-1 ring-slate-200/70 dark:ring-slate-700/70 hover:ring-gold-500 dark:hover:ring-gold-500 overflow-hidden transition-all duration-700 ease-out"
          >
            <div className="relative overflow-hidden">
              <img
                src={item.image}
                alt={item.name || "Property listing"}
                loading="lazy"
                decoding="async"
                width="800"
                height="500"
                className="w-full h-72 md:h-80 object-cover group-hover:scale-105 transition-transform duration-[1200ms] ease-out"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-slate-900/60 via-transparent to-transparent"></div>
              <div className="absolute top-5 start-5">
                <CategoryBadge category={item.category} />
              </div>
              <div className="absolute bottom-5 start-5 end-5 flex items-end justify-between text-white">
                <div className="flex items-center text-sm tracking-wide">
                  <FiMapPin className="me-2" />
                  <span className="line-clamp-1">{item.address}</span>
                </div>
              </div>
            </div>

            <div className="p-7">
              <h4 className="font-display text-2xl text-slate-900 dark:text-white leading-snug group-hover:text-gold-600 dark:group-hover:text-gold-400 transition-colors duration-500 mb-4">
                {item.name}
              </h4>

              <ul className="py-5 border-y border-slate-100 dark:border-gray-800 flex items-center flex-wrap gap-y-2 list-none">
                {renderCardFeatures(item)}
              </ul>

              <div className="flex justify-between items-end mt-6">
                <div>
                  <p className="font-display italic text-gold-600 text-xs tracking-[0.25em] uppercase mb-1">
                    Pricing
                  </p>
                  <p className="font-display text-2xl text-slate-900 dark:text-white">
                    {item.price}
                  </p>
                </div>
                <span className="inline-flex items-center gap-2 text-slate-500 dark:text-slate-400 group-hover:text-gold-600 dark:group-hover:text-gold-400 font-display italic text-sm transition-colors duration-500">
                  View Details
                  <FiArrowUpRight className="group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform duration-500" />
                </span>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
